/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import "devextreme/dist/css/dx.light.css";
import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { getDDMMYYYFormat, getHHmmFormat, setUtcTime } from "../../../../helper/dateTimeHelper";
import {
  InputTextArea,
  InputText,
  InputDateTime,
  InputSelect,
  InputNumber,
  InputArrayData,
} from "../../../../components/input";
import { InputWraper, useForm } from "../../../../modules/form";
import { useSelector } from "../../../../store/store";
import { CreateNotification } from "../../../../components/notifier";
import { Icon } from "../../../../components/icon";
import { ITRepairInfoService } from "../../../../services/it-repair/itRepairInfo.service";
import { MailService } from "../../../../services/mail/mail.service";
import { Button } from "../../../../modules/button";
import { ITToolsService } from "../../../../services/it-tools-request/itTool.service";
import RadioGroup from "devextreme-react/radio-group";
import {
  department,
  unitNB,
  unitTSN,
  unitDN,
  hq1Team,
  hq2Team,
  hq3Team,
  psc1Team,
  psc2Team,
  psc3Team,
  pvhk1Team,
  pvhk2Team,
  pvhk3Team,
} from "../data";

import { getEnv } from "../../../../AppConfigs";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../constants/statusConstants";

import { Col, Row } from "react-bootstrap";
import { getDay, getDiffDay, getLocalDate } from "../../../../helper/dateTimeHelper";
import { repairRequestTypes } from "./repairRequestType";
import { RepairProcessContentForm, RepairProcessContentStructure } from "./repairToolForm";
import { UserSelect } from "../../../../components/input/select/UserSelect";
import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { Upload } from "../../upload";
import { validateRequests } from "../../../../services/util";
import { Asset } from "../../../../services/department-viags/asset.service";
import { AssetModal } from "../../modal/asset-modal";
import { useQueryClient } from "@tanstack/react-query";
import { eApproveTitleCode } from "../../../../constants/bizTitle";

const siteUrl = getEnv("REACT_APP_APPROVER_IT_TOOLS_REPAIR_REQUEST_URL");

export const renewRepairToolsPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { id } = useRouteMatch().params as any;
  const employees = useSelector((state: any) => state.employee.employees);
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const user = useSelector((state: any) => state.user);
  const currentUserName = user?.current?.username;
  const [approverOptions, setApproverOptions] = useState([]);

  const today = new Date();
  const [brokenDate, setBrokenDate] = useState(today);
  const [dayOfIncreaseDate, setDayOfIncreaseDate] = useState("" as string);

  const [repairDate, setRepairDate] = useState("" as string);
  //Get tools
  const [iTTools, setITTools] = useState([]);
  const [iTToolSelected, setITToolSelected] = useState(null as any);

  const [approver, setApprover] = useState(null as any);
  const [iTLead, setITLead] = useState(null as any);
  const [requestType, setRequestType] = useState(repairRequestTypes[0].value);
  const [userDepartment, setUserDepartment] = useState(null as any);
  //radio button value
  const [prioritiesSelected, setPrioritiesSelected] = useState("Thấp");
  const [fixOptionsSelected, setFixOptionsSelected] = useState("Sửa chữa");
  const [deviceLocation, setDeviceLocation] = useState(null as any);
  const [originalPrice, setOriginalPrice] = useState(null as any);
  const [residualValue, setResidualValue] = useState(null as any);
  const [selectedDepartment, setSelectedDepartment] = useState(null as any);
  const [selectedUnit, setSelectedUnit] = useState(null as any);
  const [selectedTeam, setSelectedTeam] = useState(null as any);
  const [unit, setUnit] = useState<any>([]);
  const [team, setTeam] = useState<any>([]);
  const priorities = ["Thấp", "Trung bình", "Cao"];
  const fixOptions = ["Sửa chữa", "Thay thiết bị mới", "Thuê ngoài", "Nhập kho"];
  const [numEditInYear, setNumEditInYear] = useState("" as string);
  const [isOpenAssetModal, setIsOpenAssetModal] = useState(false);
  const [assetCodeValue, setAssetCodeValue] = useState("" as string);
  const queryClient = useQueryClient();

  const { getInputProps, handleSubmit, isSubmitting, setValues } = useForm({
    structure: [
      {
        name: "devicetype",
        label: "Loại thiết bị",
      },
      {
        name: "unit",
        label: "Đơn vị",
      },
      {
        name: "codeTSCC",
        label: "Mã TS/CC",
        // defaultValue: {}
      },
      {
        name: "union",
        label: "Đội/Tổ",
      },
      {
        name: "deviceLocation",
        label: "Vị trí/Người sử dụng thiết bị",
      },
      {
        name: "brokenDate",
        label: "Ngày hỏng",
      },
      {
        name: "dayofIncrease",
        label: "Ngày tăng",
      },
      {
        name: "cost",
        label: "Nguyên giá",
      },
      {
        name: "residualValue",
        label: "Giá trị còn lại",
      },
      {
        name: "numEditsInYear",
        label: "Số lần sửa trong năm",
      },
      {
        name: "lastEdit",
        label: "Lần sửa gần nhất",
      },
      {
        name: "priority",
        label: "Độ ưu tiên",
      },
      {
        name: "casefix",
        label: "Phương án sửa chữa",
      },
      {
        name: "corruptedSymptoms",
        label: "Hiện tượng hỏng",
      },
      {
        name: "Cause",
        label: "Nguyên nhân:",
      },
      {
        name: "deparment",
        label: "Cơ quan/Đơn vị",
      },
      {
        name: "pickApprover",
        label: "Chọn CQ/ĐV nghiệm thu",
      },
      {
        name: "findApprover",
        label: "Chọn cán bộ CNTT",
      },
      {
        name: "findApproverReplace",
        label: "Chọn thủ trưởng CQ/ĐV thay thế",
      },
      {
        name: "type",
        label: "Đề Nghị",
      },
      {
        name: "requests",
        label: "",
        defaultValue: [],
      },
      {
        name: "fileRequests",
        label: "Tệp đính kèm",
        defaultValue: [],
      },
    ],

    onSubmit: async (payload) => {
      const { residualValue, cost, requests, fileRequests, deviceLocation, corruptedSymptoms, Cause, codeTSCC } =
        payload;

      if (requests.length === 0) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }

      /**
       * Validate data of requests is valid ??
       */
      if (requests.length) {
        const isValidateAllRequests = validateRequests(requests);

        if (!isValidateAllRequests) {
          CreateNotification({
            title: "Thông báo",
            body: "Phương án sửa chữa đề xuất chứa dữ liệu không hợp lệ!",
            icon: "/icons/warning.png",
          });
          return;
        }
      }

      if (!approver) {
        CreateNotification({ title: "Thông báo", body: "Vui lòng chọn cán bộ thực hiện", icon: "/icons/warning.png" });
        return;
      }

      if (!iTLead) {
        CreateNotification({ title: "Thông báo", body: "Vui lòng chọn thủ trưởng CQ/ĐV!", icon: "/icons/warning.png" });
        return;
      }

      let brokenTime = 0;
      // let dayOfIncreaseTime = 0;
      // let repairDateTime = 0;
      const broken = brokenDate.setHours(brokenTime, 0, 0);
      // const dayOfIncrease = dayOfIncreaseDate.setHours(dayOfIncreaseTime, 0, 0);
      // const repairLastDate = repairDate.setHours(repairDateTime, 0, 0);
      const software: any = softwares.find((f: any) => f.eSystemCode === "ITR");
      const itTool: any = iTTools.find((f: any) => f.id == iTToolSelected.value || f.id == iTToolSelected);
      const approverTmp = employees.find((f: any) => f.eMail === approver?.userPrincipalName?.toLowerCase());
      const itLeadTmp = employees.find((f: any) => f.eMail === iTLead?.value?.toLowerCase());
      const createdJobTitle = employees.find((f: any) => f.eMail === user?.current?.username?.toLowerCase());
      const createdHistory = [
        {
          id: "created",
          value: new Date(),
          modifiedDate: new Date(),
          user: user.current.name,
        },
        {
          id: "broken",
          value: new Date(),
          modifiedDate: new Date(),
          user: user.current.name,
        },
      ];
      const iTRepairInfos: any = {
        fields: {
          Title: `Sửa chữa CNTT - ${itTool.Title}`,
          eSoftwareId: software.id,
          eToolTypeId: itTool.id,
          eDepartment: selectedDepartment.value,
          eUnitRoom: selectedUnit.value,
          eUnion: selectedTeam.value,
          eDepartmentID: selectedUnit.id,
          ECodeTCSSId: assetCodeValue || codeTSCC,
          ePriority: prioritiesSelected,
          eRepair: fixOptionsSelected,
          eDeviceLocation: deviceLocation,
          eBrokenDate: setUtcTime(getDay(broken)),
          eDayOfIncrease: dayOfIncreaseDate,
          eLastEdit: repairDate || "",
          eCost: cost ? cost : 0,
          eResidualValue: residualValue ? residualValue : 0,
          eNumEditsInYear: numEditInYear || "",
          eCorruptedSymptoms: corruptedSymptoms,
          eCause: Cause,
          eApprovedBy: approverTmp
            ? `${approverTmp.eMail}|${approverTmp.Title}|${approverTmp.eBizTitle}`
            : id == 0
            ? `${approver.userPrincipalName}|${approver.displayName}|${approver.jobTitle}`
            : approver,
          eRequestType: requestType,
          eRequestStatus: requestStatus.submitted,
          eContent: JSON.stringify(requests),
          eFileContent: JSON.stringify(fileRequests),
          // eApprovedByITLead: itLeadTmp ? `${itLeadTmp.eMail}|${itLeadTmp.Title}|${itLeadTmp.eBizTitle}` : id == 0 ? `${iTLead.value}|${iTLead.label}|${iTLead.biz}` : iTLead,
          eApprovedByITHead: `${software.eITHead}|${software.eITHeadName}|Đội trưởng - KCQ`,
          eAssignee: itLeadTmp
            ? `${itLeadTmp.eMail}|${itLeadTmp.Title}|${itLeadTmp.eBizTitle}`
            : `${iTLead.value}|${iTLead.label}|${iTLead.biz}`,
          ePhoneNumber: createdJobTitle?.eBizTitle,
          eCreateName: createdJobTitle?.Title,
          eUpdateHistory: JSON.stringify(createdHistory),
        },
      };
      addITRepairInfo(iTRepairInfos);
    },
  });

  const sendMail = async (approver: any, itRepairToolRequest: any) => {
    const url = siteUrl + "/details/" + itRepairToolRequest.id;
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === "ITRRA");
    const content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(mailRegexs.two + ";", itRepairToolRequest.createdBy.user.displayName)
      .replace(mailRegexs.nine + ";", itRepairToolRequest.id)
      .replace(mailRegexs.ten + ";", itRepairToolRequest.fields.eDescription ?? "")
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(itRepairToolRequest.createdDateTime)} - ${getHHmmFormat(
          itRepairToolRequest.createdDateTime,
        )}`,
      )
      .replace(mailRegexs.siteUrl, url);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  //Date broken and Rising
  const onBrokenDateChange = (date: any) => {
    const newDate = new Date(date);
    setBrokenDate(newDate);
    const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(brokenDate)));
    if (days < 0) {
      setBrokenDate(newDate);
    }
  };

  // const onDayOfIncreaseDateChange = (date: any) => {
  //   const newDate = new Date(date);
  //   setDayOfIncreaseDate(newDate);
  //   const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(dayOfIncreaseDate)));
  //   if (days < 0) {
  //     setDayOfIncreaseDate(newDate);
  //   }
  //   setTimeout(() => setMinDate(newDate), 0);
  // }
  //Repair date
  // const onRepairDateChange = (date: any) => {
  //   const newDate = new Date(date);
  //   setRepairDate(newDate);
  //   const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(dayOfIncreaseDate)));
  //   if (days < 0) {
  //     setRepairDate(newDate);
  //   }
  //   setTimeout(() => setMinDate(newDate), 0);
  // }
  // End Date Broken and Rising

  const addITRepairInfo = (ITRepairInfos: any) => {
    ITRepairInfoService.addITRepairInfo(ITRepairInfos).then(
      (res) => {
        // if (assetList.length > 0) {
        //   const infoPromises: any[] = [];
        //   assetList.forEach((e: any) => {
        //     infoPromises.push(AssetService.updateNumberUpdate(e.codeAsset));
        //   })
        //   Promise.all(assetList);
        // }
        CreateNotification({ title: "Thành công", body: `Tạo yêu cầu thành công.`, icon: "/icons/success.png" });
        if (ITRepairInfos.fields.eApprovedBy) {
          sendMail(ITRepairInfos.fields.eApprovedBy, res);
        }
        queryClient.invalidateQueries({ queryKey: ["repair-tools-requests"] });
        history.push(Routes.repairITToolDetailPage.path.replace(":id", res.id));
      },
      (error) => {
        CreateNotification({ title: "Thất bại", body: `Tạo yêu cầu thất bại.`, icon: "/icons/error.png" });
        console.log(error);
      },
    );
  };
  //Input type of device
  const onItToolChange = (selectedOptions: any) => {
    setITToolSelected(selectedOptions ? selectedOptions : "");
  };

  const getITTools = async () => {
    ITToolsService.getToolsType()
      .then((res: any) => {
        setITTools(res);
      })
      .catch((error) => {
        CreateNotification({
          title: "Thông báo",
          body: "Không thể lấy danh sách loại công cụ",
          icon: "/icons/error.png",
        });
        console.log(error);
      });
  };

  const checkUserDepartment = () => {
    const userDepartment = employees.find((o: any) => o.eMail?.toLowerCase() === currentUserName?.toLowerCase());
    setUserDepartment(userDepartment);
  };

  //radio change
  const onPriorityChange = (e: any) => {
    setPrioritiesSelected(e);
  };

  const onFixOptionsChange = (e: any) => {
    setFixOptionsSelected(e);
  };

  const onDepartmentChange = (selectedOptions: any) => {
    setApprover("");
    setSelectedDepartment(selectedOptions ? selectedOptions : null);
    setSelectedTeam(null);
    setTeam([]);
    if (selectedOptions && typeof selectedOptions.id === "string") {
      setSelectedUnit(selectedOptions);
      setSelectedTeam(selectedOptions);
    }
  };

  const onUnitChange = (selectedOptions: any) => {
    setSelectedUnit(selectedOptions ? selectedOptions : null);
    setApprover("");
    setSelectedTeam(null);
  };

  const onTeamChange = (selectedOptions: any) => {
    setSelectedTeam(selectedOptions ? selectedOptions : null);
  };

  const onITLeadPickerChange = (selectedOptions: any) => {
    if (selectedOptions?.target?.selectedPeople[0]) {
      const obj = {
        label: selectedOptions?.target?.selectedPeople[0]?.displayName,
        value: selectedOptions?.target?.selectedPeople[0]?.userPrincipalName,
        biz: selectedOptions?.target?.selectedPeople[0]?.jobTitle,
        default: false,
      };
      setITLead(obj);
    }
  };

  const onApproverChange = (selectedOptions: any) => {
    setITLead(selectedOptions ? selectedOptions : null);
  };

  const onApproverPickerChange = (selectedOptions: any) => {
    setApprover(selectedOptions.target.selectedPeople[0]);
  };

  const getApproverOptions = () => {
    let approvers: any = [];
    if (selectedDepartment && selectedDepartment.id > 0 && selectedUnit)
      approvers = employees
        .filter((f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedUnit.id)
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          biz: o.eBizTitle,
          default: o.eDefault || false,
        }));
    else if (selectedDepartment && selectedDepartment.id != 0)
      approvers = employees
        .filter(
          (f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedDepartment.id,
        )
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          biz: o.eBizTitle,
          default: o.eDefault || false,
        }));
    setApproverOptions(approvers);
  };

  const onCloseAssetModal = () => {
    setIsOpenAssetModal(false);
  };

  const onConfirm = (assets: Asset[]) => {
    const listAssetCode = assets.map((e: any) => e.codeAsset);
    const listIncreasingDate = assets.map((e: any) => getDDMMYYYFormat(e.increasingDate));
    const listRepairDate = assets.map((e: any) => getDDMMYYYFormat(e.updatedDate));
    const listNumOfUpdate = assets.map((e: any) => e.numOfUpdate);
    // if (ref.current)
    //   ref.current.value = (listAssetCode.join('; '));
    if (assets.length > 0) {
      setAssetCodeValue(listAssetCode.join("; "));
      setRepairDate(listRepairDate.join("; "));
      setNumEditInYear(listNumOfUpdate.join("; "));
      setDayOfIncreaseDate(listIncreasingDate.join("; "));
    }
  };

  //Set hook cho Cơ quan/Đơn vị
  useEffect(() => {
    if (selectedDepartment) {
      if (selectedDepartment.id === 2) {
        setUnit(unitNB);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 3) {
        setUnit(unitDN);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 1) {
        setUnit(unitTSN);
        setSelectedUnit(null);
      } else {
        setUnit([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
        setSelectedUnit(selectedDepartment);
      }
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (selectedUnit && selectedUnit.id) {
      if (selectedDepartment.id === 1 || selectedDepartment.id === 2 || selectedDepartment.id === 3) {
        const id = +selectedUnit?.id?.slice(-1);
        const key = selectedUnit?.id?.slice(0, -1);
        if (key === "HQ") setTeam(id === 1 ? hq1Team : id === 2 ? hq2Team : id === 3 ? hq3Team : []);
        else if (key === "PSC") setTeam(id === 1 ? psc1Team : id === 2 ? psc2Team : id === 3 ? psc3Team : []);
        else if (key === "PVHK") setTeam(id === 1 ? pvhk1Team : id === 2 ? pvhk2Team : id === 3 ? pvhk3Team : []);
        else if (key === "GA") setTeam([{ id: "GA", value: "Bộ phận hành chính tổng hợp" }]);
        else if (key === "PVHH") setTeam([{ id: "PVHH", value: "Đội phục vụ hàng hóa" }]);
        else {
          setTeam([{ id: selectedUnit.id, value: selectedUnit.value }]);
          setSelectedTeam(selectedUnit);
        }
      } else {
        setTeam([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
        setSelectedTeam(selectedDepartment);
      }
    }
  }, [selectedUnit]);

  useEffect(() => {
    getApproverOptions();
  }, [selectedDepartment, selectedUnit]);

  //Type tool
  useEffect(() => {
    getITTools();
  }, [setITTools]);

  useEffect(() => {
    if (id != 0) {
      ITRepairInfoService.getITRepairInfo(id)
        .then((res) => {
          const {
            eUnitRoom,
            eDepartmentID,
            ECodeTCSSId,
            eApprovedBy,
            eToolTypeId,
            eRequestType,
            eContent,
            eFileContent,
            eDeviceLocation,
            eCorruptedSymptoms,
            eCause,
            ePriority,
            eRepair,
            eCost,
            eBrokenDate,
            eDayOfIncrease,
            eLastEdit,
            eNumEditsInYear,
            eResidualValue,
            ePhoneNumber,
          } = res.fields;
          setValues({
            requests: JSON.parse(eContent),
            fileRequests: eFileContent ? JSON.parse(eFileContent) : [],
            codeTSCC: ECodeTCSSId,
            corruptedSymptoms: eCorruptedSymptoms,
            Cause: eCause,
            deviceLocation: eDeviceLocation,
            unitRoom: eUnitRoom,
            cost: eCost,
            brokenDate: eBrokenDate,
            numEditsInYear: eNumEditsInYear,
            residualValue: eResidualValue,
            lastEdit: eLastEdit,
            dayofIncrease: eDayOfIncrease,
            phoneNumber: ePhoneNumber,
            eDepartmentID: eDepartmentID,
          });
          setRequestType(eRequestType);
          setPrioritiesSelected(ePriority);
          setFixOptionsSelected(eRepair);
          setITToolSelected(eToolTypeId);
          setDeviceLocation(eDeviceLocation);
          // setSelectedDepartment(eDepartment);
          // setSelectedUnit(eUnitRoom);
          // setSelectedTeam(eUnion);
          setOriginalPrice(eCost);
          setApprover(eApprovedBy);
          setResidualValue(eResidualValue);
          setAssetCodeValue(ECodeTCSSId);
          setDayOfIncreaseDate(eDayOfIncrease);
          setNumEditInYear(eNumEditsInYear);
          setRepairDate(eLastEdit);
        })
        .catch((error) => console.log(error));
    }
  }, [id]);

  useEffect(() => {
    if (employees && employees.length > 0) {
      checkUserDepartment();
    }
  }, [employees]);

  useEffect(() => {
    if (userDepartment) {
      getApproverOptions();
    }
  }, [userDepartment]);

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureRepairTools.path)}>
              <Icon.ArrowLeft />
            </div>
            {"Tạo yêu cầu sửa chữa công cụ CNTT"}
          </div>
        </div>
        <Col>
          <form onSubmit={handleSubmit}>
            <Box title="I. Thông tin thiết bị:">
              <Row>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("devicetype")}
                    renderInput={(s) => (
                      <InputSelect
                        {...s}
                        options={iTTools.map((o: any) => ({
                          label: o.Title,
                          value: o.id,
                        }))}
                        value={iTToolSelected}
                        onChange={onItToolChange}
                        placeholder="* Chọn thiết bị"
                      />
                    )}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("codeTSCC")}
                    renderInput={(s) => (
                      <InputText {...s} value={assetCodeValue} isDisabled={true} />
                      // <Select
                      //   options={codeTSCCTools.map((o: any) => ({ label:o.field_0 + " - " + o.Title, value: o.field_0 + " - " + o.Title, department: o.field_2, location: o?.field_3, originalPrice: o.Nguy_x00ea_ngi_x00e1_,residualValue: o.Gi_x00e1_tr_x1ecb_c_x00f2_nl_x1e  }))}
                      //   value={codeTSCCToolSelected}
                      //   onChange={onCodeTSCCToolChange}
                      //   onFocus={() => setCodeTSCCToolSelected(null)}
                      //   onInputChange={onInputTSCCChange}
                      //   placeholder={codeTSCCToolSelected ? codeTSCCToolSelected : "* Vui lòng nhập mã TSCC"} />
                      // }
                      // <InputAutoComplete
                      //   {...s}
                      //   itTools={codeTSCCTools.map((e: any) => e.value)}
                      //   onChange={handleTextAutoCompleteChange}
                      //   onSelectedChange={handleSelectedChange}
                      // />
                    )}
                  />
                  <p
                    onClick={() => setIsOpenAssetModal(true)}
                    style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                  >
                    Mở danh sách tài sản
                  </p>
                </Col>
              </Row>
              {true && (
                <Row>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("deparment")}
                      renderInput={(s) => (
                        <InputSelect
                          {...s}
                          options={department.map((o: any) => ({
                            id: o.id,
                            label: o.value,
                            value: o.value,
                          }))}
                          value={selectedDepartment}
                          onChange={onDepartmentChange}
                          placeholder="* Chọn Cơ quan/ đơn vị"
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("unit")}
                      renderInput={(s) => (
                        <InputSelect
                          {...s}
                          options={unit.map((o: any) => ({
                            id: o.id,
                            label: o.value,
                            value: o.value,
                          }))}
                          value={selectedUnit?.value}
                          onChange={onUnitChange}
                          placeholder={"* Chọn đơn vị"}
                        />
                      )}
                    />
                  </Col>
                </Row>
              )}
              <Row>
                {true && (
                  <Col xs={true ? 12 : 0} md={id == 0 ? 6 : 0}>
                    <InputWraper
                      inputProps={getInputProps("union")}
                      renderInput={(s) => (
                        <InputSelect
                          {...s}
                          options={team.map((o: any) => ({
                            id: o.id,
                            label: o.value,
                            value: o.value,
                          }))}
                          value={selectedTeam?.value}
                          onChange={onTeamChange}
                          placeholder="* Chọn đội/tổ"
                        />
                      )}
                    />
                  </Col>
                )}
                <Col xs={12} md={true ? 6 : 12}>
                  <InputWraper
                    inputProps={getInputProps("deviceLocation")}
                    renderInput={(s) => <InputText {...s} defaultValue={deviceLocation} value={deviceLocation} />}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("brokenDate")}
                    renderInput={(s) => (
                      <>
                        <InputDateTime {...s} isDisabled={true} value={brokenDate} onChange={onBrokenDateChange} />
                      </>
                    )}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("dayofIncrease")}
                    renderInput={(s) => <InputText {...s} value={dayOfIncreaseDate} isDisabled={true} />}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("cost")}
                    renderInput={(s) => <InputNumber {...s} value={originalPrice} />}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("residualValue")}
                    renderInput={(s) => <InputNumber {...s} value={residualValue} />}
                  />
                  {getInputProps("residualValue")?.value > getInputProps("cost")?.value && (
                    <p className="text-danger px-2">❗ Giá trị còn lại phải nhỏ hơn đơn giá</p>
                  )}
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("numEditsInYear")}
                    renderInput={(s) => <InputText {...s} value={numEditInYear} isDisabled={true} />}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("lastEdit")}
                    renderInput={(s) => <InputText {...s} value={repairDate} isDisabled={true} />}
                  />
                </Col>
              </Row>
              <Row>
                {/* Damage Phenomenon */}
                <Col xs={9} md={9}>
                  <InputWraper
                    inputProps={getInputProps("corruptedSymptoms")}
                    renderInput={(s) => <InputText {...s} />}
                    isRequired
                  />
                </Col>
                <Col xs={3} md={3}>
                  <InputWraper
                    inputProps={getInputProps("priority")}
                    renderInput={(s) => (
                      <Col className="d-flex radio-priority-content">
                        <RadioGroup
                          dataSource={priorities}
                          onValueChange={onPriorityChange}
                          value={prioritiesSelected ? prioritiesSelected : priorities[0]}
                          layout="horizontal"
                        />
                      </Col>
                    )}
                  />
                </Col>
              </Row>
            </Box>

            <Box title="II. Đội CNTT chuẩn đoán nguyên nhân:">
              <InputWraper inputProps={getInputProps("Cause")} component={InputTextArea} />
            </Box>

            <Box title="III. Phương án đề xuất" className="form__content">
              <Row className="d-flex Radio-btn-repair">
                <Col xs={12} md={12}>
                  <RadioGroup
                    id="radio-group-content"
                    dataSource={fixOptions}
                    onValueChange={onFixOptionsChange}
                    value={fixOptionsSelected ? fixOptionsSelected : fixOptions[0]}
                    layout="horizontal"
                  />
                </Col>
              </Row>
              <Row className="px-3">
                <InputWraper
                  className="from__container-input"
                  inputProps={getInputProps("requests")}
                  renderInput={(state) => (
                    <InputArrayData
                      {...state}
                      form={RepairProcessContentForm}
                      structure={RepairProcessContentStructure}
                      excelTemplate="repair-tool"
                    />
                  )}
                />
              </Row>

              <InputWraper inputProps={getInputProps("fileRequests")} renderInput={(s) => <Upload {...s} />} />

              {true && (
                <Row>
                  <Col sm="12" md="12">
                    <InputWraper
                      inputProps={getInputProps("findApprover")}
                      renderInput={(s) => (
                        <div className="people_picker-custom">
                          <PeoplePicker
                            className="people-picker"
                            placeholder="Vui lòng chọn người cần gửi tới"
                            type={PersonType.any}
                            selectionChanged={onApproverPickerChange}
                          />
                        </div>
                      )}
                      isRequired
                    />
                  </Col>
                </Row>
              )}
              {true && (
                <Row className="py-4">
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("pickApprover")}
                      renderInput={(s) => (
                        <UserSelect
                          {...s}
                          placeholder="Vui lòng chọn CQ/ĐV Nghiệm thu"
                          options={approverOptions}
                          value={iTLead}
                          onChange={onApproverChange}
                        />
                      )}
                      isRequired
                    />
                  </Col>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("findApproverReplace")}
                      renderInput={(s) => (
                        <div className="people_picker-custom">
                          <PeoplePicker
                            className="people-picker"
                            placeholder="Vui lòng chọn CQ/ĐV nghiệm thu"
                            type={PersonType.any}
                            selectionChanged={onITLeadPickerChange}
                          />
                        </div>
                      )}
                    />
                  </Col>
                </Row>
              )}
            </Box>

            <div className="textRight">
              <Button type="submit" label="Xác nhận" isLoading={isSubmitting} />
              <Button
                type="button"
                label="Huỷ"
                buttonType="danger-outline"
                className="ml10"
                onClick={() => history.push(Routes.procedureRepairTools.path)}
              />
            </div>
          </form>
        </Col>
      </div>
      <AssetModal onConfirm={onConfirm} isOpen={isOpenAssetModal} onClose={onCloseAssetModal} />
    </div>
  );
});
